export default __webpack_public_path__ + "static/media/V550MANB4.6e922461.pdf";